import { createSearchAction } from 'redux-search';
import { GAMES_RESOURCE_NAME } from '../../constants/search';

export const gameSearchAction = createSearchAction(GAMES_RESOURCE_NAME);

export const setSearchText = (payload) => ({
  ...gameSearchAction(payload),
});
